var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10Z",
    stroke: "#E2E4E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1598 14V13.0455L10.1129 9.9858C10.4283 9.65341 10.6882 9.36222 10.8928 9.11222C11.1001 8.85937 11.255 8.61932 11.3572 8.39205C11.4595 8.16477 11.5107 7.9233 11.5107 7.66761C11.5107 7.37784 11.4425 7.12784 11.3061 6.91761C11.1697 6.70455 10.9837 6.54119 10.7479 6.42756C10.5121 6.31108 10.2464 6.25284 9.95099 6.25284C9.63849 6.25284 9.36577 6.31676 9.13281 6.4446C8.89986 6.57244 8.72088 6.75284 8.59588 6.9858C8.47088 7.21875 8.40838 7.49148 8.40838 7.80398H7.15128C7.15128 7.27273 7.27344 6.80824 7.51776 6.41051C7.76207 6.01278 8.0973 5.70455 8.52344 5.4858C8.94957 5.2642 9.43395 5.15341 9.97656 5.15341C10.5249 5.15341 11.0078 5.26278 11.4254 5.48153C11.8459 5.69744 12.174 5.9929 12.4098 6.3679C12.6456 6.74006 12.7635 7.16051 12.7635 7.62926C12.7635 7.95312 12.7024 8.26989 12.5803 8.57955C12.4609 8.8892 12.2521 9.23437 11.9538 9.61506C11.6555 9.9929 11.2408 10.4517 10.7095 10.9915L8.97514 12.8068V12.8707H12.9041V14H7.1598Z",
    fill: "#525866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon (5).8172e614ed41cd9ade2c92a8eab967a6.svg";
export { ForwardRef as ReactComponent };